import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import HelpIcon from '../../../assets/HelpIcon'
import SettingsIcon from '../../../assets/SettingsIcon'
import HomeIcon from '../../../assets/HomeIcon'
import HomeFillIcon from '../../../assets/HomeFillIcon'
import SettingsFillIcon from '../../../assets/SettingsFillIcon'
import HelpFillIcon from '../../../assets/HelpFillIcon'

import './SideMenu.scss'
import {
  HEADER_CONFIG,
  SIDEBAR_CONST,
} from '../../../common/constant/common-constant'
import { navigate, redirect } from '../../../common/utils/redirectionUtils'
import {
  MOBILE_SIDEMENU_VISIBLE_SCREENS,
  // MOBILE_SIDEMENU_VISIBLE_SCREENS,
  PAGE_CONST,
  PERMISSION_FEATURE,
  PERMISSION_SCREEN,
  PERMISSION_TYPE,
} from '../../../common/constant/page-constant'

import useCheckMobileScreen from '../../../common/hooks/use-check-mobile-screen-hook'

const SideMenu = (props) => {
  const isMobile = useCheckMobileScreen()
  const [activeItem, setActiveItem] = useState('')
  const [permissions, setPermissions] = useState({})

  useEffect(() => {
    if (props.activeItem) setActiveItem(props.activeItem)
  }, [props.activeItem])

  const handleHeaderConfig = (title) => {
    // headerAction
    // HEADER_CONFIG.IS_BACK_VISIBLE: false,
  }

  useEffect(() => {
    if (props.loginData.permissions) {
      console.log('props.loginData.permissions: ', props.loginData.permissions)
      let permission = props.loginData.permissions.reduce((acc, permission) => {
        acc.features = {
          ...acc.features,
          ...permission.features,
        }
        return acc
      }, {})
      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  const handleClick = (item) => {
    setActiveItem(item)
    switch (item) {
      case SIDEBAR_CONST.HOME:
        navigate(PAGE_CONST.HOME)
        break
      case SIDEBAR_CONST.SETTINGS:
        !isMobile
          ? navigate(PAGE_CONST.SETTINGS)
          : navigate(PAGE_CONST.SETTINGS_MOBILE_MENU)
        break
      case SIDEBAR_CONST.HELP:
        navigate(PAGE_CONST.HELP)
        break
      default:
        break
    }
  }

  return (
    (!isMobile ||
      MOBILE_SIDEMENU_VISIBLE_SCREENS.includes(props?.component)) && (
      <nav className="sideMenu fixed">
        <ul className="navbarMenu">
          <li
            className={`navbarIcon ${
              activeItem === PAGE_CONST.HOME ? 'active' : ''
            }`}
            onClick={() => handleClick(SIDEBAR_CONST.HOME)}
          >
            {activeItem !== 'HOME' ? <HomeIcon /> : <HomeFillIcon />}
          </li>
          <li
            className={`navbarIcon ${
              activeItem === PAGE_CONST.SETTINGS ? 'active' : ''
            }`}
            onClick={() => handleClick(SIDEBAR_CONST.SETTINGS)}
          >
            {activeItem !== 'SETTINGS' ? (
              <SettingsIcon />
            ) : (
              <SettingsFillIcon />
            )}
          </li>
          {permissions?.features?.[PERMISSION_FEATURE.QUERY] !==
            PERMISSION_TYPE.RESTRICTED && (
            <li
              className={`navbarIcon ${
                activeItem === PAGE_CONST.HELP ? 'active' : ''
              }`}
              onClick={() => handleClick(SIDEBAR_CONST.HELP)}
            >
              {activeItem !== 'HELP' ? <HelpIcon /> : <HelpFillIcon />}
            </li>
          )}
        </ul>
      </nav>
    )
  )
}

const mapStateToProps = (state) => {
  return {
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(SideMenu)
